import React from 'react';
import { Tag, TagProps } from '@chakra-ui/react';

type LabelProps = TagProps & {
    children: React.ReactNode;
};

export function Label({ children, ...rest }: LabelProps) {
    return (
        <Tag
            size="sm"
            colorScheme="gray"
            color="gray.900"
            fontWeight="400"
            lineHeight="1.5rem"
            {...rest}>
            {children}
        </Tag>
    );
}
